import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InsertJurisdictionResourcesMutationVariables = Types.Exact<{
  objects: Array<Types.Jurisdiction_Resources_Insert_Input> | Types.Jurisdiction_Resources_Insert_Input;
}>;


export type InsertJurisdictionResourcesMutation = { __typename?: 'mutation_root', insert_jurisdiction_resources?: { __typename?: 'jurisdiction_resources_mutation_response', affected_rows: number } | null };


export const InsertJurisdictionResourcesDocument = gql`
    mutation insertJurisdictionResources($objects: [jurisdiction_resources_insert_input!]!) {
  insert_jurisdiction_resources(objects: $objects) {
    affected_rows
  }
}
    `;
export type InsertJurisdictionResourcesMutationFn = Apollo.MutationFunction<InsertJurisdictionResourcesMutation, InsertJurisdictionResourcesMutationVariables>;

/**
 * __useInsertJurisdictionResourcesMutation__
 *
 * To run a mutation, you first call `useInsertJurisdictionResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertJurisdictionResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertJurisdictionResourcesMutation, { data, loading, error }] = useInsertJurisdictionResourcesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertJurisdictionResourcesMutation(baseOptions?: Apollo.MutationHookOptions<InsertJurisdictionResourcesMutation, InsertJurisdictionResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertJurisdictionResourcesMutation, InsertJurisdictionResourcesMutationVariables>(InsertJurisdictionResourcesDocument, options);
      }
export type InsertJurisdictionResourcesMutationHookResult = ReturnType<typeof useInsertJurisdictionResourcesMutation>;
export type InsertJurisdictionResourcesMutationResult = Apollo.MutationResult<InsertJurisdictionResourcesMutation>;
export type InsertJurisdictionResourcesMutationOptions = Apollo.BaseMutationOptions<InsertJurisdictionResourcesMutation, InsertJurisdictionResourcesMutationVariables>;